import Sockette from 'sockette';

import { formatMessage } from '@/i18n';
import EventEmitter, {
  READER_CONNECT_CHANGED,
  SDK_CONNECT_CHANGED,
  // SDK_CONNECT_DONE,
  // SDK_CONNECT_INTERRUPTED,
  FINGERPRINT_DOWNLOADING_PROGRESS,
  SDK_CODE_MISMATCH,
  DYNAMIC_LOCKNO_COLLECTED,
  PAD_CONNECT_CHANGED,
  FINGERPRINT_GETTING_SIGNAL,
  KEY_INIT,
  SDK_OCCUPIED_BY_OTHERS,
} from '@/tool/events';

import { transformException } from '../HM/Exceptions';

import * as Events from './Events';
// TODO: 这里用的还是HM接口的方法，后期统一一下
import getExceptionCodes from './Exceptions';

export default class Scoket {
  socket = null;

  // 是否已经连接完成的标志
  hasConnected = false;

  // 是否已经注册完成的标志
  hasRegistered = false;

  // 是否已经进行连接失败提示的标志
  hasRemindError = false;

  // 发送命令时的结果处理handler
  handlers = [];

  // 发送注册命令时的结果处理handler
  registerHandler = null;

  // 上一次Reader的连接标志
  lastReaderStatus = false;

  // 是否允许重连的标志
  blockReconnect = false;

  onMessage = e => {
    const data = JSON.parse(e.data);
    const ExceptionCodes = getExceptionCodes();
    const {
      cmd,
      data: { status, device, multitask },
    } = data;
    // 心跳包忽略处理
    // TODO: 后期加入读取百分比显示，暂时忽略
    if (cmd == Events.HEARTBEAT || cmd == Events.READ_PROGRESS) return;
    console.log(data);
    if (cmd == Events.USB_KEY) {
      if (this.lastReaderStatus != status) {
        // EventEmitter.emit(READER_CONNECT_CHANGED, status == 'on')
        const deviceConnected = status === 'on';
        EventEmitter.emit(
          READER_CONNECT_CHANGED,
          deviceConnected,
          deviceConnected ? device : null,
          deviceConnected ? multitask : null
        ); // 断开的情况下，清空model
        this.lastReaderStatus = status;
      }
    } else if (cmd == Events.USB_PAD) {
      // TODO: 需要判断上一次连接状态吗？
      EventEmitter.emit(PAD_CONNECT_CHANGED, status == 'on');
    } else if (cmd == Events.DONWLOADING_FINGERPRINT_PROGRESS) {
      // console.warn(cmd, data);
      EventEmitter.emit(FINGERPRINT_DOWNLOADING_PROGRESS, data.data);
    } else if (cmd == Events.DYNAMIC_LOCKNO_COLLECTED) {
      if (data.result > 0) EventEmitter.emit(DYNAMIC_LOCKNO_COLLECTED, data.data);
    } else if (cmd == Events.GETTING_FINGERPRINT) {
      EventEmitter.emit(FINGERPRINT_GETTING_SIGNAL, data.data.action);
    } else {
      // console.log(data);
      // if (false) {
      // eslint-disable-next-line no-lonely-if
      if (this.registerHandler) {
        const [resolve, reject] = this.registerHandler;
        if (data.result >= 0) {
          resolve(data.data);
          this.hasRegistered = true;
        } else reject(ExceptionCodes[data.result * -1]);
        this.registerHandler = null;
      } else if (this.handlers.length > 0) {
        const [resolve, reject] = this.handlers[0];
        // console.log(data.result);
        try {
          if (data.result >= 0) {
            resolve(data.data);
          } else {
            const errorCode = data.result * -1;
            reject(ExceptionCodes[errorCode] || formatMessage('hardware.unknown.error'));
            if (errorCode === 4115) EventEmitter.emit(SDK_CODE_MISMATCH);
            else if (errorCode === 4118) EventEmitter.emit(KEY_INIT);
          }
        } catch (err) {
          // TODO: 这里直接返回的e是json解析失败的错误是字符串：Unexpected token...需不需要进一步处理
          reject(err);
        }
        this.handlers.shift();
      }
    }
  };

  onOpen = () => {
    console.warn('xxxxxxxx socket opened xxxxxxxxxxx');
    this.hasConnected = true;
    this.hasRemindError = false;

    // 如果当前是阻止重连的模式，再手动改回允许重连
    if (this.blockReconnect) this.blockReconnect = false;

    EventEmitter.emit(SDK_CONNECT_CHANGED, true);
  };

  onClose = e => {
    console.warn('socket closed', e);
    this.hasConnected = false;
    this.hasRegistered = false;

    this.lastReaderStatus = false;

    if (!this.hasRemindError) {
      EventEmitter.emit(READER_CONNECT_CHANGED, false, null);
      EventEmitter.emit(SDK_CONNECT_CHANGED, false);
      this.hasRemindError = true;
    }

    if (e.code === 1001 && e.reason === 'occupied by other client') {
      EventEmitter.emit(SDK_OCCUPIED_BY_OTHERS);
    }
  };

  onOverload = () => {
    console.log('socket overload');
  };

  onReconnecting = () => {
    console.log('socket reconnecting');
  };

  onError = e => {
    console.log('socket error occured');
    if (this.blockReconnect) {
      // eslint-disable-next-line no-unused-vars
      e.target.onclose = ev => {
        console.log('manually stopped reconnecting');
      };
    }
  };

  connect(url) {
    // TODO: 如果在IE下连接的websocket主机是localhost，必须取消IE内容设置里面的内网取消相关勾选，才可以进行通讯，
    // 否则会报SCRIPT5022: SecurityError错误，加个try catch避免中断
    try {
      this.socket = new Sockette(url, {
        // maxAttempts : -1,
        timeout: 2000, // 2s超时时间
        onopen: this.onOpen,
        onclose: this.onClose,
        onreconnect: this.onReconnecting,
        onerror: this.onError,
        onmaximum: this.onOverload,
        onmessage: this.onMessage,
      });
    } catch (e) {
      console.warn(e);
    }
    // 每次请求链接时把错误的提示状态更新为false，防止重新登陆后无法弹出错误提示
    this.hasRemindError = false;
  }

  disconnect() {
    if (this.socket) {
      console.log('ready to disconnect');
      this.socket.close(1000);
    }
    // 再退出到登陆界面后，充值以下错误提醒状态;
    // this.hasRemindError = false;
  }

  stopReconnect() {
    // if (this.socket) {
    //     this.socket.close(1005);
    // }
    this.blockReconnect = true;
  }

  send(cmd, data) {
    const body = { cmd, data };
    return new Promise((resolve, reject) => {
      if (this.socket && this.hasConnected && this.hasRegistered) {
        this.handlers.push([resolve, reject, cmd]);
        this.socket.json(body);
      } else reject(transformException({ error: 'Socket is not connected' }));
    });
  }

  reigster(cmd, data) {
    const body = { cmd, data };
    console.log(body);
    return new Promise((resolve, reject) => {
      if (this.socket && this.hasConnected) {
        console.log('send register cmd');
        this.registerHandler = [resolve, reject];
        this.socket.json(body);
      } else reject(transformException({ error: 'Socket is not connected' }));
    });
  }
}
